import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { DirectivesModule } from "src/app/directives/directives.module";
import { AddressSelectorModule } from "../../address-selector/address-selector.module";
import { QuestionsModule } from "../../questions/questions.module";
import { SharedModule } from "../../shared/shared.module";
import { BankDetailsConfirmComponent } from "./bank-details-confirm/bank-details-confirm.component";
import { BankDetailsContentComponent } from "./bank-details-content/bank-details-content.component";
import { BankDetailsQuestionPageComponent } from "./bank-details-question-page/bank-details-question-page.component";
import { BankDetailsComponent } from "./bank-details.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    DirectivesModule,
    AddressSelectorModule,
    QuestionsModule
  ],
  exports: [
    BankDetailsComponent
  ],
  declarations: [
    BankDetailsComponent,

    BankDetailsQuestionPageComponent,
    BankDetailsContentComponent,
    BankDetailsConfirmComponent
  ]
})
export class BankDetailsModule { }
